import { BaseService } from '../../../infra/base.service'
import { FormV2TemplatesRepository } from './form-v2-templates.repository'
import type { FormV2Template } from './form-v2-template'

export class FormV2TemplatesService extends BaseService<FormV2Template> {
    constructor(private rep: FormV2TemplatesRepository) {
        super(rep)
    }

    async generateFromFile(dto: { filename: string; content: string }) {
        return await this.rep.generateFromFile(dto)
    }
}
